/**
 * Image Gallery Hook
 * ==================
 * React Query hook for fetching all product images.
 */

import { useQuery } from '@tanstack/react-query'
import { imageGalleryApi } from '@/services/api'
import type { ImageGalleryParams, PaginatedResponse, ImageGalleryItem } from '@/types'

export function useImageGallery(params?: ImageGalleryParams) {
  return useQuery<PaginatedResponse<ImageGalleryItem>>({
    queryKey: ['image-gallery', params],
    queryFn: () => imageGalleryApi.list(params),
  })
}
